// SalaryBonusCalculator.js
import React, { useState } from "react";
import MainCalculatorsList from "./MainCalculators";
import RelatedLinks from "../RelatedLinks";
import { SecondAds,    FirstAds , MobileUnderCalAds } from "../../Ads";
import SharedHelmet from "../Helmet";
const TITLE = "Kalkulator Kenaikan Gaji";
const DESCRIPTION =
  "Gunakan kalkulator kenaikan gaji untuk menghitung nilai kenaikan yang akan Anda terima berdasarkan persentase tertentu dari gaji pokok Anda.";
const KEYWORDS =
  "kalkulator kenaikan gaji, hitung kenaikan gaji, persentase kenaikan, gaji pokok, kalkulator keuangan";
const OG_URL =
  "https://do-calculate.com/calculator/id/salary-bonus-calculator/";
function SalaryBonusCalculator() {
  const [salary, setSalary] = useState("");
  const [percentage, setPercentage] = useState("");
  const [result, setResult] = useState(null);
  const [steps, setSteps] = useState([]);
  const [error, setError] = useState("");
  const handleCalculate = () => {
    try {
      if (!salary || !percentage) {
        setError("Harap masukkan gaji dan persentase.");
        return;
      }
      const basicSalary = parseFloat(salary);
      const bonusPercentage = parseFloat(percentage) / 100;
      const bonusAmount = (basicSalary * bonusPercentage).toFixed(2);
      const total = parseInt(basicSalary) + parseInt(bonusAmount);
      const step1 = `Gaji Pokok: ${basicSalary}`;
      const step2 = `Persentase Kenaikan: ${bonusPercentage * 100}%`;
      const step3 = `Perhitungan Kenaikan: ${basicSalary} × ${bonusPercentage} = ${bonusAmount}`;
      const step4 = `Gaji Setelah Kenaikan: ${total}`;
      setSteps([step1, step2, step3, step4]);
      setResult(bonusAmount);
      setError("");
    } catch (err) {
      setError("Terjadi kesalahan saat menghitung. Silakan coba lagi.");
    }
  };
  return (
    <div>
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ height: "50px" }}
          >
            <h1 style={{ fontSize: "17px" }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                <p>
                  Apakah Anda ingin memahami cara menghitung kenaikan gaji? Kalkulator ini memberikan penjelasan sederhana tentang proses perhitungan. Dengan memasukkan gaji pokok Anda dan persentase kenaikan, Anda akan mendapatkan hasil akhir, serta penjelasan tentang cara menerapkan rumus persentase untuk menghitung kenaikan.
                </p>
                <p>
                  <strong>
                    Kenaikan = Gaji Pokok × (Persentase ÷ 100)
                  </strong>
                </p>
                <ul>
                  <li>
                    Masukkan gaji pokok dan persentase kenaikan untuk menghitung nilai kenaikan finansial.
                  </li>
                </ul>
                <p>
                  Untuk mencapai kenaikan gaji, nilai kenaikan dihitung dengan mengalikan gaji pokok dengan persentase kenaikan dibagi 100. Kalkulator ini melakukan perhitungan secara otomatis. Masukkan gaji pokok dan persentase kenaikan, dan Anda akan mendapatkan nilai kenaikan baru, serta penjelasan sederhana tentang cara menerapkan rumus persentase untuk menghitung kenaikan.
                </p>
                <p>
                  Kalkulator ini dikembangkan untuk memudahkan proses perhitungan kenaikan dengan penjelasan langkah-langkah untuk memastikan pemahaman yang lengkap.
                </p>
                <hr />
              </div>
              <br />
            </div>
            <MobileUnderCalAds/>
            <div className="row">
              <div className="col-sm-12 col-md-7 calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  <h2 style={{ fontSize: "16px" }}>{TITLE}</h2>
                </div>
                <div >
                  <div>
                    <hr />
                    <div className="form-group" htmlFor="salary">
                      <label className="form-label ms-2" htmlFor="percentage">
                        Masukkan Gaji Pokok
                      </label>
                      <input
                        id="salary"
                        type="number"
                        value={salary}
                        onChange={(e) => setSalary(e.target.value)}
                        placeholder="Masukkan gaji pokok"
                        className="form-control"
                        style={{ width: "75%" }}
                      />
                    </div>
                    <div className="form-group">
                      <label className="form-label ms-2">
                        Masukkan Persentase Kenaikan (%)
                      </label>
                      <input
                        id="percentage"
                        type="number"
                        value={percentage}
                        onChange={(e) => setPercentage(e.target.value)}
                        placeholder="Masukkan persentase"
                        className="form-control"
                        style={{ width: "75%" }}
                      />
                    </div>
                    <br />
                    <button
                      className="btn btn-success"
                      style={{ fontSize: "20px", marginLeft: "10px" }}
                      onClick={handleCalculate}
                    >
                      Hitung
                    </button>
                  </div>
                  <br />
                  { error !== "" && (
                    <p className="p-3 mb-2 bg-warning text-black">
                      Error: {error}
                    </p>
                  )}
                  {result &&  (
                    <>
                      <div className="p-3 mb-2 bg-success">
                        <h4 className="text-white">Hasil: {result} </h4>
                      </div>
                      <div
                        className="p-3 mb-2 bg-info text-black"
                        style={{ width: "100%" }}
                      >
                        <p className="text-black">
                          <strong>Langkah-langkah:</strong>
                        </p>
                        <ul className="p-3 mb-2 bg-info text-black">
                          {steps.map((step, index) => (
                            <li key={index}>{step}</li>
                          ))}
                        </ul>
                      </div>
                    </>
                  )}
                  <hr />
                </div>
              </div>
            </div>
            <hr />            <div className="row">
              <RelatedLinks />
              <hr />
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList></MainCalculatorsList>
          <br />
        </div>
      </div>
      <div className="row" style={{ height: "auto" }}>
        <div className="col-12 col-md-8">
          <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header">Apa itu Kenaikan Gaji?</div>
              <div className="info-section-body">
                <div>
                  <u>
                    <h2 style={{ fontSize: "16px" }}>
                      Konsep Kenaikan Gaji
                    </h2>
                  </u>
                  <p>
                    Kenaikan gaji adalah jumlah tambahan yang diterima karyawan sebagai bagian dari gaji bulanan mereka. Kenaikan ini biasanya merupakan persentase dari gaji pokok karyawan, dan ditambahkan ke gaji setelah dihitung. Kenaikan ini bisa sebagai hasil dari kinerja yang sangat baik, atau kenaikan biaya hidup, atau alasan lain yang ditentukan oleh manajemen.
                  </p>
                  <div className="p-3 mb-2 bg-info text-black">
                    Contoh: Jika gaji pokok Anda adalah 4000 Rupiah dan ditentukan kenaikan sebesar 5%, maka kenaikannya adalah: 4000 × 0.05 = 200 Rupiah
                  </div>
                </div>
                <hr />
                <div>
                  <u>
                    <h2 style={{ fontSize: "16px" }}>Cara Menghitung Kenaikan</h2>
                  </u>
                  <p>Untuk menghitung kenaikan gaji, ikuti langkah-langkah berikut:</p>
                  <ul>
                    <li>Masukkan gaji pokok dalam rumus yang sesuai.</li>
                    <li>Masukkan persentase kenaikan.</li>
                    <li>
                      Kalikan gaji pokok dengan persentase untuk mendapatkan nilai kenaikan.
                    </li>
                    <li>
                      Tambahkan nilai kenaikan ke gaji pokok untuk mendapatkan gaji baru.
                    </li>
                  </ul>
                  <div className="p-3 mb-2 bg-info text-black">
                    Contoh: Jika gaji pokok Anda adalah 5000 Rupiah dan kenaikannya 8%, maka kenaikannya adalah: 5000 × 0.08 = 400 Rupiah
                  </div>
                </div>
                <hr />
                <div>
                  <u>
                    <h2 style={{ fontSize: "16px" }}>Pertanyaan Umum</h2>
                  </u>
                  <p>
                    Jawaban untuk beberapa pertanyaan umum tentang kenaikan gaji dan perhitungannya.
                  </p>
                  <div className="p-3 mb-2 bg-info text-black">
                    Pertanyaan: Mengapa kenaikan ditentukan sebagai persentase?
                    <br />
                    Jawaban: Menentukan kenaikan sebagai persentase memungkinkan penyesuaian jumlah tambahan berdasarkan besarnya gaji pokok, memastikan kenaikan adil untuk semua karyawan.
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
         </div>
</div>
  );
}
export default SalaryBonusCalculator;